import React from 'react';
import PropTypes from 'prop-types';

const Tel = ({ telString }) => {
	let number, protocol;
	if (telString) {
		[protocol, number] = telString.split(':');
		if (protocol && number) {
			return (
				<React.Fragment>
					<em className="fa fa-phone-square"/>&nbsp;
					<a href={telString}>{number}</a>
				</React.Fragment>
			);
		}
		if (telString && telString.length === 10) {
			return (
				<React.Fragment>
					<em className="fa fa-phone-square" />&nbsp;
					<span>{telString.substring(0, 3)}-{telString.substring(3, 6)}-{telString.substring(6)}</span>
				</React.Fragment>
			);
		}
		return (
			<React.Fragment>
				<em className="fa fa-phone-square" />&nbsp;
				<span>{telString}</span>
			</React.Fragment>
		);
	}
	return null;
};
Tel.propTypes = {
	telString: PropTypes.string
};

export default Tel;
